<template>
  <div class="cashOut">
    <!--头部-->
    <van-nav-bar class="wallet-header":border="false">
      <span class="cash-explain" slot="right" @click="openExplain">提现说明</span>
    </van-nav-bar>
    <div style="width: 100%;height: 46px"></div>
    <div class="card-con">
      <div class="not-card" v-if="!selectCard.bankNumber" @click="goCashBankCard">
        <div class="text-con">未选择银行卡</div>
        <div class="right-icon-con">
          <span class="right-icon"></span>
        </div>
      </div>
      <div class="card" v-if="selectCard.bankNumber" @click="goCashBankCard">
        <div class="icon-con">
          <img class="icon" :src="selectCard.phoneURL" alt="">
        </div>
        <div class="text">尾号 {{ selectCard.bankNumber | last4 }}</div>
        <div class="right-icon-con">
          <span class="right-icon"></span>
        </div>
      </div>
    </div>
    <van-cell title="提现金额"></van-cell>
    <van-form
        ref="form"
        label-align="center"
    >
      <van-field
          v-model="money"
          clearable
          type="number"
          maxLength="8"
          label="提现金额"
          placeholder="请输入提现金额"
          :rules="[
            {required: true, message: '必填'},
            { pattern: /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/, message: '请输入正确的金额' },
            {validator: validatorMax, message: balance<10 ? '余额大于10元方可提现' : `当前可提现金额为 10 ~ ${ balance } 元`}
          ]"
      >
      </van-field>
    </van-form>

    <div class="cash-balance">当前余额：{{ balance | filter2 }}</div>

    <div class="btn-con">
      <van-button type="info" size="large" @click="cashBtn">确认提现</van-button>
    </div>
    <!--  奖金余额提现说明  -->
    <van-dialog
        v-model="showCashExplain"
        class="cash-out-explain-dialog"
    >
      <div class="header-title">提现说明</div>
      <ul class="text-list">
        <li class="text">奖金余额≥ {{ (minWithdrawalAmount-0).toFixed(2) }} 元时可发出提现申请；</li>
        <li class="text">每周最多提现一次；</li>
        <li class="text">单笔费率为 {{ ( withdrawalRatio*100).toFixed(2) }} %；</li>
        <li class="text">为了奖金余额能及时到达您的账户，提现之前请先绑定银行卡；</li>
        <li class="text">奖金余额提现于T+2到账；</li>
        <li class="text">奖金余额提现如遇节假日则顺延。</li>
      </ul>
    </van-dialog>

    <!--  服务余额提现说明  -->
    <van-dialog
        v-model="showServiceCashExplain"
        class="cash-out-explain-dialog"
    >
      <div class="header-title">提现说明</div>
      <ul class="text-list">
        <li class="text">服务余额≥ {{ (minWithdrawalAmount-0).toFixed(2) }} 元时可发出提现申请；</li>
        <li class="text">每月10日可提现一次；</li>
        <li class="text">单笔费率为 {{ ( withdrawalRatio*100).toFixed(2) }} %；</li>
        <li class="text">为了服务余额能及时到达您的账户，提现之前请先绑定公司账户银行卡；</li>
        <li class="text">服务余额提现于T+2到账；</li>
        <li class="text">服务余额提现如遇节假日则顺延；</li>
        <li class="text">提现前，需提供6%增值税发票至平台客服。</li>
      </ul>
    </van-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cashRule } from '@/api/pay/payApi'
import { getCashWallet } from '@/api/wallet/cash'
export default {
  components: {
  },
  data () {
    return {
      balance: 0,//现金钱包余额
      walletAccount: '',//现金钱包地址
      money: '',
      minWithdrawalAmount: 10, //最小提现金额
      maxAmount: 10, //最大提现金额(当前余额)
      withdrawalRatio: 0.02, //提现手续费
      showCashExplain: false,
      showServiceCashExplain: false,

    }
  },
  computed:{
    ...mapGetters([
      'selectCard'
    ])
  },
  filters:{
    last4(val){
      const a = val+'';
      return a.slice(a.length-4, a.length)
    }
  },
  created(){
    this.getCashWallet()
  },

  methods:{

    goCashBankCard(){
      this.$router.push({name: 'cashBankCard'})
    },

    // 获取现金钱包详情
    getCashWallet(){
      getCashWallet({userOpenid: this.session('userOpenId'), walletType: this.$route.query.walletType}).then(res=>{
        this.balance = res.data.availableAmount
        this.walletAccount = res.data.account
        this.cashRule()
      })
    },

    cashBtn(){
      console.log(this.amount)
      if(!this.selectCard.bankNumber){
        this.$toast('请选择银行卡！')
        return false
      }
      this.$refs['form'].validate().then(()=>{
        let req = {
          money: this.money,
          walletAccount: this.walletAccount,
          bankName: this.selectCard.bankName,
          cardNumber: this.selectCard.bankNumber,
          fromUserOpenId: this.session('userOpenId'),
          fromWalletType: this.$route.query.walletType, // 0：个人钱包，1：店铺钱包,2：服务商
          rate: this.withdrawalRatio, // 提现费率
        }
        this.$store.dispatch('my/changeWithdrawalData', req)
        this.$router.push({ name: 'cashOutConfirm' })
      })
    },


    // 提现手续费
    cashRule(){
      cashRule({walletAccount: this.walletAccount}).then(res=>{
        this.minWithdrawalAmount = res.data.minWithdrawalAmount || 10;
        this.withdrawalRatio = res.data.withdrawalRatio || 0.02;
      })
    },

    openExplain(){
      if(this.$route.query.walletType==='0'){
        this.showCashExplain = true
      }else if(this.$route.query.walletType==='2'){
        this.showServiceCashExplain = true
      }
    },


    validatorMax(value){
      if(value){
        if(this.balance<10){// 余额不满10元无法提现
          return false
        }else {
          if(value<10 || value>this.balance){
            return false
          }else {
            return true
          }
        }
      }else {
        return false
      }
    },
  }
}
</script>

<style scoped lang="less">
.cashOut{
  .wallet-header {
    background-color: transparent;
    position: absolute;
    z-index: 9;
    width: 100%;
    .van-nav-bar__left {
      .van-icon {
        color: #fff !important;
      }
    }
    .van-nav-bar__title {
      color: #fff;
    }
    .cash-explain{
      color: #000;font-size: 14px;
    }
  }
  .card-con{
    padding: 12px;
    .not-card{
      display: flex;
      height: 70px;
      border-radius: 8px;
      box-shadow: 0 0 1px 1px #cdcdcd;
      margin-bottom: 12px;
      .text-con{
        flex: 1;
        color: #a0a0a0;font-size: 14px;
        display: inline-flex;justify-content: flex-end;align-items: center;
      }
      .right-icon-con{
        width: 40px;
        display: inline-flex;justify-content: center;align-items: center;
        .right-icon{
          display: block;width: 8.5px;height: 17px;
          background: url("../../../assets/my/icon-right.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
    .card{
      display: flex;
      height: 70px;
      border-radius: 8px;
      box-shadow: 0 0 1px 1px #cdcdcd;
      margin-bottom: 12px;
      .icon-con{
        flex: 1;
        padding: 0 0 0 6px;
        display: inline-flex;align-items: center;
        .icon{
          min-width: 126px;
          min-height: 36px;
          max-width: 90%;
          max-height: 90%;
        }
      }
      .text{
        width: 80px;font-size: 14px;padding-right: 12px;color: #777;
        display: inline-flex;justify-content: flex-end;align-items: center;
      }
      .right-icon-con{
        width: 40px;
        display: inline-flex;justify-content: center;align-items: center;
        .right-icon{
          display: block;width: 8.5px;height: 17px;
          background: url("../../../assets/my/icon-right.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
  }


  .cash-balance{
    padding: 12px;
    font-size: 14px;
    color: #aaa;
  }
  .btn-con{
    padding: 40px 15px 0;
  }

}
</style>
<style lang="less">
.cashOut{
  .cash-number{
    font-size: 30px;
  }
}
.cash-out-explain-dialog{
  border-radius: 15px;
  padding: 12px;
  font-size: 13px;
  .header-title{
    font-weight: bold;font-size: 17px;color: #333;line-height: 1;padding: 2px 0;text-align: center;
  }
  .text-list{
    list-style: disc;padding-left: 24px;
    .text{line-height: 24px;}
  }

}
</style>
